import { MENTION_PATTERN } from 'src/components/GenerationTask/MultiColumnGenerationForm/ImageToVideo/MultiReference/PromptEditor/types'

export type MediaKind = 'image' | 'video' | 'audio'

export type MentionMediaMap = {
  imageMediaIds: string[]
  videoMediaIds: string[]
  audioMediaIds: string[]
}

const KIND_LIST_KEY: Record<MediaKind, keyof MentionMediaMap> = {
  image: 'imageMediaIds',
  video: 'videoMediaIds',
  audio: 'audioMediaIds',
}

export type ParsedMentionSegment =
  | { type: 'text'; text: string }
  | { type: 'mention'; kind: MediaKind; index: number; mediaId: string }

export function parseMentionsInText(
  text: string,
  mediaMap: MentionMediaMap,
): ParsedMentionSegment[] {
  const segments: ParsedMentionSegment[] = []
  let lastIndex = 0

  for (const match of text.matchAll(MENTION_PATTERN)) {
    const matchIdx = match.index ?? 0
    if (matchIdx > lastIndex) {
      segments.push({ type: 'text', text: text.slice(lastIndex, matchIdx) })
    }
    const kind = match[1].toLowerCase() as MediaKind
    const index = Number(match[2])
    const mediaId = mediaMap[KIND_LIST_KEY[kind]]?.[index - 1]
    if (mediaId) {
      segments.push({ type: 'mention', kind, index, mediaId })
    } else {
      segments.push({ type: 'text', text: match[0] })
    }
    lastIndex = matchIdx + match[0].length
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', text: text.slice(lastIndex) })
  }

  return segments
}
